import { Box, Tooltip } from '@mui/material';
import { RobotOutlined } from '@ant-design/icons';
import IconButton from 'components/@extended/IconButton';
import { useAiChatContext } from 'components/AiChat/AiChatProvider';

const AiChatTrigger = () => {
  const { available, open, toggle } = useAiChatContext();

  if (!available) return null;

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title="AI Assistant">
        <IconButton
          color={open ? 'primary' : 'secondary'}
          variant={open ? 'contained' : 'light'}
          sx={{ color: open ? '#fff' : 'text.primary' }}
          onClick={toggle}
        >
          <RobotOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default AiChatTrigger;
